'use strict';

module.exports.Command = require('./command');
module.exports.CommandHandler = require('./handler');


//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/dist/browser/src/commands/index.js
// module id = hHrf
// module chunks = 0